import { render, staticRenderFns } from "./PerfilAcessoEditTabAccount.vue?vue&type=template&id=006215d6&"
import script from "./PerfilAcessoEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./PerfilAcessoEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./PerfilAcessoEditTabAccount.vue?vue&type=style&index=0&id=006215d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports